import { Object3D, Vector3 } from "three";
import Image from "../_app/cuchillo/3D/Image";
import { GetBy } from "../_app/cuchillo/core/Element";
import WebGLSketch from "../_app/cuchillo/3D/WebGLSketch";
import GridCanvas from "../components/GridCanvas";
import { ControllerPage } from "../_app/cuchillo/pages/ControllerPage";

export default class Box extends Object3D {
  dom;
  items = [];
  primary;

  constructor(__dom) {
    super();

    this.dom = __dom;

    const index = parseInt(this.dom.dataset.index);
    this.index = index;

    const prim = GetBy.selector('[data-image-primary]', __dom)[0];
    if (prim) {
      const primary3D = new Image({
        dom: prim,
        size: {
          y: parseInt(prim.dataset.height),
          x: parseInt(prim.dataset.width)
        }
      });

      this.add(primary3D);
      this.items.push(primary3D);
      this.primary = primary3D;
    }

    const next = GetBy.selector('[data-next]', __dom)[0];
    if (next) {
      const next3D = new Image({
        dom: next,
        size: {
          y: parseInt(next.dataset.height),
          x: parseInt(next.dataset.width)
        }
      });
      next3D.mesh.userData.onClick = () => {
        GridCanvas.next(this.index);
      }
      next3D.mesh.userData.isClickable = true;
      WebGLSketch.addInteractive(next3D.mesh);

      this.add(next3D);
      this.items.push(next3D);
    }

    const info = GetBy.selector('[data-info]', __dom)[0];
    if (info) {
      const info3D = new Image({
        dom: info,
        size: {
          y: parseInt(info.dataset.height),
          x: parseInt(info.dataset.width)
        }
      });
      info3D.mesh.userData.onClick = () => {
        ControllerPage.changePage(info3D.mesh.userData.link);
      };
      info3D.mesh.userData.isClickable = true;
      info3D.mesh.userData.link = info.href;

      this.add(info3D);
      this.items.push(info3D);
      WebGLSketch.addInteractive(info3D.mesh);
    }
  }

  update() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].update();
    }
  }

  resize() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].resize();
    }
  }

  dispose() {
    for (let i = 0; i < this.items.length; i++) {
      this.remove(this.items[i]);
      WebGLSketch.removeInteractive(this.items[i].mesh);
      this.items[i].dispose();
    }
  }
}
